var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"UserComponent",attrs:{"href":`/profile/${_vm.notification.user.id}/`}},[_vm._v(_vm._s(_vm.notification.user.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }